import { gql } from '@apollo/client';

export const LINE_ITEM_CUSTOM_PACING_FIELDS = gql`
  fragment lineItemCustomPacingFields on LineItemV5 {
    id
    schedule {
      timezone
      dateRangeList {
        startDate
        endDate
        pacingShare
      }
      dayPartList {
        firstActiveHour
        lastActiveHour
        activeDayList
      }
      deliveryInViewerTime
    }
    customPacingApplied
  }
`;
